import React from 'react'

const ProjectNav = ({step, visit, paymentType}) => {

  const actualStep = step
  const isSinglePayment = paymentType === 'single'
  const isPaymentOptionSelected = paymentType !== undefined && paymentType !== null

  let steps = [
    'Signature du devis',
    'Option paiement',
  ]

  if (isPaymentOptionSelected && !isSinglePayment && actualStep > 1) {
    steps.push('Paiement acompte')
  } else {
    steps.push('Paiement')
  }

  steps.push('Prise de rendez-vous')
  steps.push('Principe de structure')
  steps.push('Édition dossier d\'étude structure')

  if (isPaymentOptionSelected && !isSinglePayment && actualStep > 1) {
    steps.push('Paiement final')
  }

  steps.push('Rendu dossier d\'étude structure')

  if (visit === "" || visit === undefined) {
    const visitIndex = steps.indexOf('Prise de rendez-vous')
    if (visitIndex !== -1) {
      steps.splice(visitIndex, 1)
    }
  }

  return (
    <>
      <div className='project-container-nav'>
        {steps.map((step, index) => {
          return (
            <div className={`project-container-nav__item ${index < actualStep ? 'valid' : index === actualStep ? 'active' : ''}`}
              key={index}
            >
              <span className='text-tertiary'>{step}</span>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default ProjectNav;